import React, { Component } from "react";
import {
  DKLabel,
  DKInput,
  DKButton,
  DKIcon,
  DKIcons,
  DKListPicker,
  INPUT_VIEW_DIRECTION,
  showAlert,
} from "deskera-ui-library";
import Utility from "../../utility/Utility";
import { PERMISSIONS } from "../../constants/Permission";

// import InviteService from "../../services/inviteService";
import ApiConstants from "../../constants/ApiConstants";
import { PRODUCTS } from "../../constants/Enum";
// import { store } from "../../redux/store";
// import { fetchUsers, getUsers } from "../../redux/slices/tenantSlice";
// import { IPermissionPayload } from "../../model/PermissionModel";

export interface InviteUserProps {
  inviteUserTapped?: (data: any) => void;
  hidePermission?: boolean;
}
export interface InviteUserState {
  inviteEmail?: any;
  inviteTapped?: any;
  needPermissionPicker?: boolean;
  permission?: any;
}
export default class InviteUser extends Component<
  InviteUserProps,
  InviteUserState
> {
  constructor(props) {
    super(props);
    this.state = {
      inviteEmail: "",
      inviteTapped: false,
      needPermissionPicker: false,
      permission: PERMISSIONS[3],
    };
  }
  render() {
    return (
      <div className="row invite-user-section parent-width border-radius-s mt-r">
        {this.getInputSection()}
        <div className="display-flex row-responsive width-auto justify-content-start align-items-end position-relative">
          {!this.props.hidePermission && this.getPermissionSection()}
          {this.getButtonSection()}
        </div>
      </div>
    );
  }
  getInputSection() {
    return (
      <DKInput
        title="Add user with email"
        errorMessage="Please enter a valid email address"
        direction={INPUT_VIEW_DIRECTION.VERTICAL}
        required={true}
        autoComplete="off"
        value={this.state.inviteEmail}
        onChange={(text) => {
          this.setState({ inviteEmail: text });
        }}
        canValidate={this.state.inviteTapped}
        type="email"
      />
    );
  }
  getPermissionSection() {
    return (
      <div className="column mr-s">
        <div
          className="row border-m border-radius-m cursor-hand position-relative p-h-s mt-s p-v-s justify-content-center"
          style={{ minWidth: "105px" }}
        >
          <DKLabel text={this.state.permission.title} className="text-gray" />
          <DKIcon
            src={DKIcons.ic_arrow_down2}
            className=" ic-xs-2 ml-xs"
            style={{ opacity: 0.4 }}
          />
          <div
            className="parent-width parent-height position-absolute"
            style={{ top: 0, left: 0 }}
            onClick={() => this.setVisibilityOfPermissionPicker(true)}
          />
          {this.state.needPermissionPicker && (
            <DKListPicker
              data={Object.keys(PERMISSIONS).map(
                (key) => PERMISSIONS[key].title
              )}
              className="position-absolute border-radius-s shadow-s-2 border-s"
              style={{ left: 0, zIndex: 2 }}
              width={100}
              onClose={() => this.setVisibilityOfPermissionPicker(false)}
              onSelect={(index) => {
                this.setVisibilityOfPermissionPicker(false);
                this.onPermissionSelect(
                  PERMISSIONS[Object.keys(PERMISSIONS)[index]]
                );
              }}
            />
          )}
        </div>
      </div>
    );
  }
  getButtonSection() {
    return (
      <DKButton
        title="Invite user"
        className="bg-button text-white fw-m"
        onClick={() => {
          this.onInvite();
        }}
      />
    );
  }
  setVisibilityOfPermissionPicker = (visible) => {
    this.setState({ needPermissionPicker: visible });
  };
  onPermissionSelect = (value) => {
    this.setState({ permission: value });
  };
  onInvite = () => {
    const { inviteEmail } = this.state;
    if (Utility.isEmpty(inviteEmail) || !Utility.isValidEmail(inviteEmail)) {
      this.setState({ inviteTapped: true });
    } else {
      let dataToSend = {
        appName: PRODUCTS.PEOPLE,
        email: inviteEmail,
        role: "paid_user",
      };
      if (this.checkDuplicateEmail(inviteEmail)) {
        showAlert("User Exists!", "User with same email already exists");
        return;
      }
      // InviteService.invite(dataToSend)
      //   .then((res) => {
      //     this.setPermission(inviteEmail);
      //     showAlert(
      //       `Invitation sent!`,
      //       `Invitation has been sent to <strong>${inviteEmail}</strong>. Please ask user to check the mail inbox for invitation email and accept it.`
      //     );
      //     this.setState({ inviteEmail: "" }, () => this.forceUpdate());
      //   })
      //   .catch((error) => {
      //     if (error?.code === 403) {
      //       showAlert(
      //         `Not Allowed!`,
      //         `Looks like you are not authorize to invite user please contact your organization owner.`
      //       );
      //     }
      //   });
    }
  };
  setPermission = (email) => {
    let permissionPayload: any = {
      users: [
        {
          email: email,
          accessLevel: this.state.permission.permissions_level,
          invitationStatus: 0,
        },
      ],
    };
    this.props.inviteUserTapped(permissionPayload);
    // store.dispatch(fetchUsers());
  };
  checkDuplicateEmail = (email) => {
    // const users = getUsers()(store.getState());
    return email// users.some((user) => user.email === email.trim());
  };
}
